(function () {
  'use strict';

  if (window.__senfinecoSparePartsLoaded) return;
  window.__senfinecoSparePartsLoaded = true;

  var STORAGE_KEY = 'sfSparePartsVehicleV1';
  var SAVED_RESTORE_KEY = 'sfSparePartsSavedRestoreV2';
  var FAVORITES_KEY = 'sfSparePartsFavoritesV1';
  var CONSUMABLES_CATEGORY_KEY = 'sfConsumablesCategoryV1';
  var CONSUMABLES_SCROLL_REQUEST_KEY = 'sfConsumablesScrollRequestV1';
  var AR =
    document.documentElement.dir === 'rtl' ||
    (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var strings = AR
    ? {
        labels: ['الماركة', 'الموديل', 'السنة', 'المحرك'],
        placeholders: ['اختر الماركة', 'اختر الموديل', 'اختر السنة', 'اختر المحرك'],
        loading: 'جاري التحميل…',
        submit: 'عرض القطع المناسبة',
        available: 'متاح للطلب',
        unavailable: 'غير متاح حاليًا',
        compatibleBrands: 'متوافق مع: ',
        favoriteAdd: 'أضف إلى المفضلة',
        favoriteRemove: 'احذف من المفضلة',
        fitmentMatch: 'تناسب سيارتك',
        fitmentMatchNote: 'مطابقة موثقة مع السيارة المحفوظة.',
        fitmentUnknown: 'تحقق من التوافق',
        fitmentUnknownNote: 'لم نجد مطابقة موثقة كافية لهذه السيارة.',
        chooseVehicle: 'اختر سيارتك أولًا',
        chooseVehicleNote: 'احفظ سيارتك لنعرض حالة التوافق مباشرة.'
      }
    : {
        labels: ['Make', 'Model', 'Year', 'Engine'],
        placeholders: ['Select make', 'Select model', 'Select year', 'Select engine'],
        loading: 'Loading…',
        submit: 'Show compatible parts',
        available: 'Available to order',
        unavailable: 'Currently unavailable',
        compatibleBrands: 'Fits: ',
        favoriteAdd: 'Add to favorites',
        favoriteRemove: 'Remove from favorites',
        fitmentMatch: 'Fits your vehicle',
        fitmentMatchNote: 'Verified match for your saved vehicle.',
        fitmentUnknown: 'Check compatibility',
        fitmentUnknownNote: 'There is not enough verified data for this vehicle.',
        chooseVehicle: 'Choose your vehicle first',
        chooseVehicleNote: 'Save a vehicle to see compatibility immediately.'
      };

  /* Curated cutout images are hosted in Shopify Files. Keep this registry flat so
     future categories only need one key + URL and inherit the same rendering. */
  var CATEGORY_IMAGE_URLS = Object.freeze({
    engine: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-engine.png?v=1787656731",
    brakes: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-brakes.png?v=1787656943",
    cooling: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cooling.png?v=1787656894",
    ac: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac.png?v=1787656899",
    suspension_steering: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-suspension-steering.png?v=1787656696",
    electrical_sensors: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electrical-sensors.jpg?v=1787656651",
    fuel_air: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-fuel-air.png?v=1787656926",
    transmission_differential: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-differential.jpg?v=1787656739",
    drivetrain: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-drivetrain.jpg?v=1787656647",
    electrical_parts: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electrical-parts.png?v=1787656933",
    exhaust: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exhaust.png?v=1787656736",
    body_accessories: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-body-accessories.png?v=1787656935",
    front_brake_pad: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-front-brake-pad.png?v=1787656949",
    rear_brake_pad: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-rear-brake-pad.png?v=1787657000",
    brake_rotor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-brake-rotor.png?v=1787657004",
    brake_hardware: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-brake-hardware.jpg?v=1787656996",
    brake_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-brakes.png?v=1787656943",
    engine_mount: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-engine-mount.png?v=1787656725",
    spark_plug: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-spark-plug.png?v=1787656903",
    ignition_coil: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ignition-coil.jpg?v=1787656728",
    engine_belt: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-engine-belt.jpg?v=1787656891",
    belt_tensioner: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-belt-tensioner.png?v=1787656633",
    pulley: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-pulley.png?v=1787656919",
    timing_belt_chain: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-timing-belt-chain.jpg?v=1787656885",
    timing_guide: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-timing-guide.jpg?v=1787656888",
    timing_sprocket: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-timing-sprocket.jpg?v=1787656922",
    internal_engine_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-internal-engine-part.png?v=1787656939",
    ignition_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ignition-part.jpg?v=1787656929",
    shock_absorber: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-shock-absorber.png?v=1787657078",
    control_arm: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-control-arm.png?v=1787657087",
    suspension_arm: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-suspension-arm.png?v=1787657090",
    bushing: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-bushing.png?v=1787657093",
    sway_bar_link: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-sway-bar-link.jpg?v=1787657095",
    bearing: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-bearing.png?v=1787657098",
    wheel_hub: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-wheel-hub.png?v=1787657102",
    steering_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-steering-part.png?v=1787657106",
    ball_joint: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ball-joint.png?v=1787657142",
    suspension_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-suspension-part.png?v=1787657109",
    water_pump: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-water-pump.png?v=1787657018",
    thermostat: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-thermostat.png?v=1787657030",
    radiator: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cooling.png?v=1787656894",
    radiator_cap: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-radiator-cap.jpg?v=1787657289",
    cooling_hose: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cooling-hose.jpg?v=1787657008",
    cooling_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cooling-part.png?v=1787657015",
    ac_compressor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac.png?v=1787656899",
    ac_evaporator: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-evaporator.png?v=1787657021",
    ac_condenser: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-condenser.png?v=1787657050",
    ac_compressor_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-compressor-sensor.jpg?v=1787657012",
    ac_valve: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-valve.png?v=1787657025",
    ac_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-sensor.jpg?v=1787657053",
    ac_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-ac-part.png?v=1787657027",
    maf_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-maf-sensor.png?v=1787657112",
    oxygen_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-oxygen-sensor.png?v=1787657114",
    knock_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-knock-sensor.jpg?v=1787657135",
    crankshaft_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-crankshaft-sensor.jpg?v=1787657148",
    camshaft_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-camshaft-sensor.jpg?v=1787657145",
    abs_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-abs-sensor.jpg?v=1787657151",
    sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-sensor.png?v=1787657155",
    fuel_injector: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-fuel-injector.png?v=1787657157",
    fuel_pump: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-fuel-air.png?v=1787656926",
    throttle_body: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-throttle-body.png?v=1787657160",
    intake_manifold: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-intake-manifold.png?v=1787657164",
    air_intake_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-air-intake-part.png?v=1787657167",
    fuel_system_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-fuel-system-part.png?v=1787657170",
    transmission_mount: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-mount.jpg?v=1787657205",
    transmission_filter: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-filter.jpg?v=1787657239",
    transmission_gasket: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-gasket.png?v=1787657219",
    transmission_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-transmission-part.png?v=1787657244",
    differential_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-differential-part.png?v=1787657235",
    cv_axle: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cv-axle.png?v=1787657197",
    cv_joint: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-cv-joint.png?v=1787657227",
    universal_joint: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-universal-joint.jpg?v=1787657265",
    driveshaft: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-driveshaft.png?v=1787657223",
    drivetrain_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-drivetrain.jpg?v=1787656647",
    exhaust_sensor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exhaust-sensor.png?v=1787657248",
    exhaust_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exhaust.png?v=1787656736",
    exhaust_accessory: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exhaust-accessory.jpg?v=1787657258",
    wiper_blade: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-body-accessories.png?v=1787656935",
    handle: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-handle.jpg?v=1787657250",
    exterior_part: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-exterior-part.png?v=1787657254",
    accessory: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-accessory.png?v=1787657261",
    starter_motor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-starter-motor.png?v=1787657230",
    alternator: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electrical-parts.png?v=1787656933",
    relay: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-relay.png?v=1787657216",
    switch: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-switch.png?v=1787657201",
    electric_motor: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electric-motor.png?v=1787657212",
    electrical_accessory: "https://cdn.shopify.com/s/files/1/0737/9700/9582/files/sf-category-electrical-accessory.jpg?v=1787657208"
  });
  var categoryImageFallbacks = new WeakMap();

  document.body && document.body.classList.add('sf-spare-parts-page');
  if (document.body) document.body.dataset.sfCardFitmentEnabled = 'true';

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return fallback;
    }
  }

  function readStorage(key, fallback) {
    try {
      return safeParse(window.localStorage.getItem(key) || '', fallback);
    } catch (_error) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_error) {
      return false;
    }
  }

  function catalogMode(scope) {
    var browser = null;
    if (scope && scope.matches && scope.matches('[data-sf-spare-parts-browser]')) {
      browser = scope;
    } else if (scope && scope.closest) {
      browser = scope.closest('[data-sf-spare-parts-browser]');
    }
    if (!browser) browser = document.querySelector('[data-sf-spare-parts-browser]');
    return browser && browser.dataset.sfPartsCatalogMode === 'consumables'
      ? 'consumables'
      : 'spare_parts';
  }

  function rememberCatalogContext(scope) {
    var mode = catalogMode(scope);
    try {
      window.sessionStorage.setItem('sfCatalogModeV1', mode);
      window.sessionStorage.setItem('sfYmmPreferredCategory', mode === 'consumables' ? 'filters' : 'parts');
    } catch (_error) {
      /* The vehicle flow remains usable when storage is unavailable. */
    }
  }

  function activePartsView(scope) {
    return catalogMode(scope) === 'consumables'
      ? 'senfineco-consumables'
      : 'senfineco-spare-parts';
  }

  function sparePartsProductUrl(value) {
    if (!value) return '';
    var view = activePartsView();
    try {
      var url = new URL(value, window.location.origin);
      url.searchParams.set('view', view);
      return url.pathname + url.search + url.hash;
    } catch (_error) {
      return value + (value.indexOf('?') === -1 ? '?' : '&') + 'view=' + view;
    }
  }

  function sparePartsResultsUrl(value) {
    var result = sparePartsProductUrl(value);
    if (!result) return '';
    try {
      var url = new URL(result, window.location.origin);
      url.hash = '';
      return url.pathname + url.search;
    } catch (_error) {
      return result.replace(/#.*$/, '');
    }
  }

  function vehicleResultsContext(value) {
    try {
      var url = new URL(value || window.location.href, window.location.origin);
      var parts = decodeURIComponent(url.pathname).split('/').filter(Boolean);
      var collectionIndex = parts.indexOf('collections');
      if (collectionIndex === -1 || !parts[collectionIndex + 1]) return null;
      var collectionHandle = parts[collectionIndex + 1];
      var taggedVehicle = parts[collectionIndex + 2] || '';
      if (/-(?:esi|esr)\d+$/i.test(collectionHandle)) {
        return {
          mode: 'collection',
          vehicleToken: collectionHandle,
          collectionHandle: collectionHandle,
          categoryTag: taggedVehicle
        };
      }
      if (/-(?:esi|esr)\d+$/i.test(taggedVehicle)) {
        return {
          mode: 'tag',
          vehicleToken: taggedVehicle,
          collectionHandle: collectionHandle,
          categoryTag: ''
        };
      }
      return null;
    } catch (_error) {
      return null;
    }
  }

  function canonicalSparePartsVehicleUrl(value) {
    try {
      var url = new URL(value || window.location.href, window.location.origin);
      var context = vehicleResultsContext(url);
      if (!context) return url;
      var parts = decodeURIComponent(url.pathname).split('/').filter(Boolean);
      var collectionIndex = parts.indexOf('collections');
      if (collectionIndex === -1) return url;
      var prefix = parts.slice(0, collectionIndex);
      url.pathname = '/' + prefix.concat(['collections', 'all', context.vehicleToken]).join('/');
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      url.searchParams.set('view', 'senfineco-spare-parts');
      url.hash = '';
      return url;
    } catch (_error) {
      return null;
    }
  }

  function isVehicleResultsPath(value) {
    return Boolean(vehicleResultsContext(value));
  }

  function validSavedResultsUrl(value, requestedMode) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !isVehicleResultsPath(url.pathname)) return '';
      var mode = requestedMode || catalogMode();
      var view = mode === 'consumables' || mode === 'senfineco-consumables'
        ? 'senfineco-consumables'
        : 'senfineco-spare-parts';
      url.hash = '';
      url.searchParams.set('view', view);
      var selection = readConsumablesSelection();
      if (view === 'senfineco-consumables') {
        url = consumablesVehicleUrl(url, selection && selection.tag, selection && selection.collectionHandle);
      } else {
        url = canonicalSparePartsVehicleUrl(url) || url;
      }
      return url.pathname + url.search;
    } catch (_error) {
      return '';
    }
  }

  function easySearchSubmit(root) {
    return root && root.querySelector('.easysearch-btn-search, #easysearch-search, .easysearch-actions-holder button[type="submit"]');
  }

  function resultsUrlFromRoot(root) {
    var submit = easySearchSubmit(root);
    var href = submit && submit.getAttribute && submit.getAttribute('href');
    if (!href || /^javascript:/i.test(href)) return '';
    return validSavedResultsUrl(sparePartsResultsUrl(href), catalogMode(root));
  }

  function readConsumablesSelection() {
    try {
      var value = safeParse(window.sessionStorage.getItem(CONSUMABLES_CATEGORY_KEY) || '', null);
      return value && value.key && value.tag ? value : null;
    } catch (_error) {
      return null;
    }
  }

  function writeConsumablesSelection(value) {
    try {
      if (!value || !value.key || !value.tag) {
        window.sessionStorage.removeItem(CONSUMABLES_CATEGORY_KEY);
        return;
      }
      window.sessionStorage.setItem(CONSUMABLES_CATEGORY_KEY, JSON.stringify({
        key: String(value.key),
        tag: String(value.tag),
        label: String(value.label || ''),
        collectionHandle: String(value.collectionHandle || '')
      }));
    } catch (_error) {
      /* Category persistence is an enhancement; the visible links still work. */
    }
  }

  function requestConsumablesResultsScroll() {
    try {
      window.sessionStorage.setItem(CONSUMABLES_SCROLL_REQUEST_KEY, String(Date.now()));
    } catch (_error) {
      /* The result remains usable when session storage is unavailable. */
    }
  }

  function consumablesResultsScrollRequested() {
    try {
      var requestedAt = Number(window.sessionStorage.getItem(CONSUMABLES_SCROLL_REQUEST_KEY) || 0);
      if (!requestedAt) return false;
      if (Date.now() - requestedAt > 60000) {
        window.sessionStorage.removeItem(CONSUMABLES_SCROLL_REQUEST_KEY);
        return false;
      }
      return true;
    } catch (_error) {
      return false;
    }
  }

  function clearConsumablesResultsScrollRequest() {
    try {
      window.sessionStorage.removeItem(CONSUMABLES_SCROLL_REQUEST_KEY);
    } catch (_error) {
      /* The request expires automatically and never blocks normal scrolling. */
    }
  }

  function consumablesVehicleUrl(value, tag, collectionHandle) {
    var url = value instanceof URL
      ? new URL(value.toString())
      : new URL(value || window.location.href, window.location.origin);
    var context = vehicleResultsContext(url);

    /* Vehicle result pages must keep the complete compatible product set in the DOM.
       Category changes are applied locally so the page never reloads or flashes. */
    if (context) {
      url = canonicalSparePartsVehicleUrl(url) || url;
    }

    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.set('view', 'senfineco-consumables');
    url.hash = '';
    return url;
  }

  function navigatePartsResults(root, event) {
    var browser = root && root.closest('[data-sf-spare-parts-browser]');
    if (!browser) return false;
    var resultsUrl = resultsUrlFromRoot(root);
    if (!resultsUrl) return false;
    var vehicle = savedVehicle();
    if (vehicle) {
      vehicle.resultsUrl = resultsUrl;
      writeStorage(STORAGE_KEY, vehicle);
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(resultsUrl);
    return true;
  }

  function normalize(value) {
    return (value || '')
      .toString()
      .normalize('NFKD')
      .replace(/[\u064B-\u065F\u0670]/g, '')
      .replace(/[_\-–—/]+/g, ' ')
      .replace(/[^\p{L}\p{N}.]+/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function setText(element, value) {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  }

  function vehicleRoot(scope) {
    return (scope || document).querySelector('[data-sf-parts-vehicle-filter]');
  }

  function appSelects(root) {
    return root ? Array.prototype.slice.call(root.querySelectorAll('.easysearch-select-holder select')) : [];
  }

  function disableEasySearchAutosubmit() {
    try {
      if (window.easysearch && window.easysearch.settings && window.easysearch.settings.form) {
        window.easysearch.settings.form.main_autosubmit = false;
      }
    } catch (_error) {
      /* EasySearch can still be completed with its explicit search action. */
    }
  }

  function selectedLabel(select) {
    if (!select || select.selectedIndex < 0 || !select.value) return '';
    var option = select.options[select.selectedIndex];
    return (option && option.textContent ? option.textContent : select.value).trim();
  }

  function selectionFromApp(root) {
    var selects = appSelects(root);
    if (selects.length < 4) return null;
    var labels = selects.slice(0, 4).map(selectedLabel);
    var values = selects.slice(0, 4).map(function (select) { return select.value || ''; });
    if (labels.some(function (label) { return !label; })) return null;
    return {
      version: 1,
      make: labels[0] || '',
      model: labels[1] || '',
      year: labels[2] || '',
      engine: labels[3] || '',
      values: values,
      label: labels.filter(Boolean).join(' · '),
      updatedAt: new Date().toISOString(),
      source: 'easysearch'
    };
  }


  function asList(value) {
    if (Array.isArray(value)) return value;
    return value === undefined || value === null || value === '' ? [] : [value];
  }

  function uniqueCandidates(values) {
    var seen = new Set();
    return values
      .flatMap(asList)
      .map(function (value) { return String(value || '').trim(); })
      .filter(function (value) {
        var key = normalize(value);
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function vehicleCandidates(vehicle, key) {
    var supplied = vehicle && vehicle.easySearchCandidates && vehicle.easySearchCandidates[key];
    var values = asList(supplied);
    if (vehicle && vehicle[key]) values.unshift(vehicle[key]);
    if (key === 'model' && vehicle && vehicle.trim) values.push(vehicle.model + ' ' + vehicle.trim);
    return uniqueCandidates(values);
  }

  function yearOptionScore(label, candidates) {
    var years = normalize(label).match(/(?:19|20)\d{2}/g) || [];
    var wanted = parseInt(candidates[0], 10);
    if (!wanted || !years.length) return 0;
    var from = parseInt(years[0], 10);
    var to = parseInt(years[1] || years[0], 10);
    return wanted >= from && wanted <= to ? 100 : 0;
  }

  function engineFacts(value) {
    var text = normalize(value);
    var litres = text.match(/\b(\d(?:\.\d{1,3})?)\s*(?:l|liter|litre)\b/i);
    var cc = text.match(/\b(\d{3,4})\s*cc\b/i);
    var displacement = litres ? parseFloat(litres[1]) : (cc ? parseInt(cc[1], 10) / 1000 : 0);
    var cylinders =
      text.match(/\b(?:v|i)\s*(3|4|5|6|8|10|12)\b/i) ||
      text.match(/\b(3|4|5|6|8|10|12)\s*(?:cylinder|cylinders|cyl|سلندر)\b/i);
    return {
      displacement: displacement ? String(Math.round(displacement * 100) / 100) : '',
      cylinders: cylinders ? cylinders[1] : ''
    };
  }

  function engineOptionScore(label, candidates) {
    var optionFacts = engineFacts(label);
    var best = 0;
    candidates.forEach(function (candidate) {
      var candidateFacts = engineFacts(candidate);
      var score = 0;
      if (candidateFacts.displacement && optionFacts.displacement === candidateFacts.displacement) score += 55;
      if (candidateFacts.cylinders && optionFacts.cylinders === candidateFacts.cylinders) score += 35;
      var left = normalize(label);
      var right = normalize(candidate);
      var leftCompact = compact(label);
      var rightCompact = compact(candidate);
      if (left === right) score = Math.max(score, 100);
      else if (leftCompact && leftCompact === rightCompact) score = Math.max(score, 96);
      else if (left.length >= 3 && right.length >= 3 && (left.indexOf(right) !== -1 || right.indexOf(left) !== -1)) score = Math.max(score, 82);
      best = Math.max(best, score);
    });
    return best;
  }

  function modelOptionScore(label, candidates) {
    var left = normalize(label);
    var leftCompact = compact(label);
    var best = 0;
    candidates.forEach(function (candidate) {
      var right = normalize(candidate);
      var rightCompact = compact(candidate);
      var score = 0;
      if (left && left === right) score = 100;
      else if (leftCompact && leftCompact === rightCompact) score = 96;
      else if (left.length >= 3 && right.length >= 3 && (left.indexOf(right) !== -1 || right.indexOf(left) !== -1)) score = 80;

      var series = (rightCompact.match(/^[a-z]{2,3}/i) || [])[0] || '';
      var numbers = rightCompact.match(/\d{3,4}/g) || [];
      if (series && leftCompact.indexOf(series) === 0) {
        score = Math.max(score, 74);
        if (numbers.some(function (number) { return leftCompact.indexOf(number) !== -1; })) {
          score = Math.max(score, 92);
        }
      }
      best = Math.max(best, score);
    });
    return best;
  }

  function optionScore(option, candidates, key) {
    var label = selectedOptionText(option);
    if (key === 'year') return yearOptionScore(label, candidates);
    if (key === 'engine') return engineOptionScore(label, candidates);
    if (key === 'model') return modelOptionScore(label, candidates);
    var left = normalize(label);
    var leftCompact = compact(label);
    var best = 0;
    candidates.forEach(function (candidate) {
      var right = normalize(candidate);
      var rightCompact = compact(candidate);
      var score = 0;
      if (left && left === right) score = 100;
      else if (leftCompact && leftCompact === rightCompact) score = 96;
      else if (left.length >= 3 && right.length >= 3 && (left.indexOf(right) !== -1 || right.indexOf(left) !== -1)) score = 80;
      best = Math.max(best, score);
    });
    return best;
  }

  function selectedOptionText(option) {
    return String((option && (option.textContent || option.label || option.value)) || '').trim();
  }

  function usableOptions(select) {
    return select
      ? Array.prototype.filter.call(select.options, function (option) {
          return option.value && !option.disabled && !option.hidden;
        })
      : [];
  }

  function bestOption(select, candidates, key) {
    var options = usableOptions(select);
    if (key === 'engine' && options.length === 1) return options[0];
    var ranked = options
      .map(function (option) { return { option: option, score: optionScore(option, candidates, key) }; })
      .sort(function (a, b) { return b.score - a.score; });
    return ranked.length && ranked[0].score >= (key === 'engine' ? 70 : 78) ? ranked[0].option : null;
  }

  function waitFor(check, timeout) {
    return new Promise(function (resolve) {
      var started = Date.now();
      var tick = function () {
        var value = check();
        if (value) return resolve(value);
        if (Date.now() - started >= timeout) return resolve(null);
        window.setTimeout(tick, 90);
      };
      tick();
    });
  }

  async function applyVehicleToEasySearch(vehicle, options) {
    options = options || {};
    var root = vehicleRoot(document);
    if (!root || !vehicle) return { ok: false, step: 'widget' };
    disableEasySearchAutosubmit();
    var selects = await waitFor(function () {
      var current = appSelects(root);
      return current.length >= 4 ? current : null;
    }, 9000);
    if (!selects) return { ok: false, step: 'widget' };
    disableEasySearchAutosubmit();

    root.dataset.sfVinApplying = 'true';
    try {
      var steps = ['make', 'model', 'year', 'engine'];
      for (var index = 0; index < steps.length; index += 1) {
        disableEasySearchAutosubmit();
        var key = steps[index];
        var select = await waitFor(function () {
          var current = appSelects(root)[index];
          return current && usableOptions(current).length ? current : null;
        }, 9000);
        if (!select) return { ok: false, step: key };
        var candidates = vehicleCandidates(vehicle, key);
        var savedValue = vehicle.values && vehicle.values[index] ? String(vehicle.values[index]) : '';
        var option = savedValue
          ? usableOptions(select).filter(function (candidate) { return String(candidate.value) === savedValue; })[0]
          : null;
        if (!option) option = bestOption(select, candidates, key);
        if (!option) return { ok: false, step: key, candidates: candidates };
        select.value = option.value;
        disableEasySearchAutosubmit();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        await new Promise(function (resolve) { window.setTimeout(resolve, 140); });
      }

      var selected = selectionFromApp(root);
      if (!selected) return { ok: false, step: 'engine' };
      selected.version = vehicle.version === 2 || vehicle.decodedFromVin || vehicle.source === 'vin' ? 2 : 1;
      selected.source = 'easysearch';
      selected.decodedFromVin = Boolean(vehicle.decodedFromVin || vehicle.source === 'vin');
      selected.vinLast4 = String(vehicle.vinLast4 || '').slice(-4);
      selected.decoder = vehicle.decoder || '';
      selected.driveType = vehicle.driveType || '';
      selected.trim = vehicle.trim || '';
      writeStorage(STORAGE_KEY, selected);
      paintSavedVehicle(selected);
      rememberCatalogContext(root);
      document.dispatchEvent(new CustomEvent('sf:parts-vehicle-change', { detail: selected }));

      if (options.submit !== false) {
        var submit = easySearchSubmit(root);
        if (!submit || submit.disabled) return { ok: false, step: 'submit', vehicle: selected };
        var href = submit.getAttribute && submit.getAttribute('href');
        if (!href || /^javascript:/i.test(href)) return { ok: false, step: 'submit', vehicle: selected };
        selected.resultsUrl = validSavedResultsUrl(sparePartsResultsUrl(href), options.mode || catalogMode(root));
        if (!selected.resultsUrl) return { ok: false, step: 'results-url', vehicle: selected };
        writeStorage(STORAGE_KEY, selected);
        window.location.replace(selected.resultsUrl);
        return { ok: true, vehicle: selected, navigating: true };
      }
      return { ok: true, vehicle: selected };
    } finally {
      delete root.dataset.sfVinApplying;
    }
  }

  function savedVehicle() {
    var vehicle = readStorage(STORAGE_KEY, null);
    return vehicle && (vehicle.version === 1 || vehicle.version === 2) && vehicle.label ? vehicle : null;
  }

  function saveSelection(root) {
    if (!root || root.dataset.sfVinApplying === 'true') return;
    var vehicle = selectionFromApp(root);
    if (!vehicle) return;
    var resultsUrl = resultsUrlFromRoot(root);
    if (resultsUrl) vehicle.resultsUrl = resultsUrl;
    rememberCatalogContext(root);
    writeStorage(STORAGE_KEY, vehicle);
    paintSavedVehicle(vehicle);
    document.dispatchEvent(new CustomEvent('sf:parts-vehicle-change', { detail: vehicle }));
  }

  function paintSavedVehicle(vehicle) {
    document.querySelectorAll('[data-sf-parts-saved-vehicle]').forEach(function (box) {
      box.hidden = !vehicle;
      var label = box.querySelector('[data-sf-parts-saved-vehicle-label]');
      if (label) label.textContent = vehicle ? vehicle.label : '';
    });
    document.querySelectorAll('[data-sf-parts-vehicle-reset]').forEach(function (button) {
      button.hidden = !vehicle;
    });
    document.querySelectorAll('[data-sf-parts-vehicle-filter]').forEach(function (root) {
      root.classList.toggle('has-saved-vehicle-results', Boolean(vehicle && isVehicleResultsPath(window.location.pathname)));
      if (!vehicle) root.classList.remove('is-restoring-saved-vehicle');
    });
  }

  function savedRestoreSignature(vehicle) {
    return [vehicle && vehicle.label, vehicle && vehicle.updatedAt, vehicle && vehicle.resultsUrl]
      .concat((vehicle && vehicle.values) || [])
      .filter(Boolean)
      .join('|');
  }

  function readSavedRestoreGuard() {
    try {
      return safeParse(window.sessionStorage.getItem(SAVED_RESTORE_KEY) || '', null);
    } catch (_error) {
      return null;
    }
  }

  function clearSavedRestoreGuard() {
    try {
      window.sessionStorage.removeItem(SAVED_RESTORE_KEY);
    } catch (_error) {
      /* The catalogue can still fall back to the visible selector. */
    }
  }

  function writeSavedRestoreGuard(vehicle) {
    try {
      window.sessionStorage.setItem(SAVED_RESTORE_KEY, JSON.stringify({
        signature: savedRestoreSignature(vehicle),
        startedAt: Date.now()
      }));
    } catch (_error) {
      /* Session storage is only a loop guard, never a requirement. */
    }
  }

  function setSavedRestoreState(root, active) {
    if (root) root.classList.toggle('is-restoring-saved-vehicle', Boolean(active));
    document.documentElement.classList.toggle('sf-saved-vehicle-restoring', Boolean(active));
  }

  async function restoreSavedVehicleResults(browser) {
    if (!browser || browser.dataset.sfPartsSavedRestoreReady === 'true') return;
    browser.dataset.sfPartsSavedRestoreReady = 'true';
    var root = browser.querySelector('[data-sf-parts-vehicle-filter]');

    if (activePartsView() === 'senfineco-spare-parts' && isVehicleResultsPath(window.location.pathname)) {
      var currentUrl = window.location.pathname + window.location.search;
      var canonicalUrl = validSavedResultsUrl(window.location.href, browser.dataset.sfPartsCatalogMode);
      if (canonicalUrl && canonicalUrl !== currentUrl) {
        window.location.replace(canonicalUrl);
        return;
      }
    }

    var vehicle = savedVehicle();
    if (!vehicle || !root) return;

    if (isVehicleResultsPath(window.location.pathname)) {
      clearSavedRestoreGuard();
      setSavedRestoreState(root, false);
      paintSavedVehicle(vehicle);
      return;
    }

    if (browser.dataset.sfPartsCatalogMode === 'consumables' && browser.dataset.sfConsumablesLanding === 'true') {
      clearSavedRestoreGuard();
      setSavedRestoreState(root, false);
      paintSavedVehicle(vehicle);
      return;
    }

    if (browser.dataset.sfPartsView !== 'root' && browser.dataset.sfPartsCatalogMode !== 'consumables') return;
    var guard = readSavedRestoreGuard();
    if (guard && guard.signature === savedRestoreSignature(vehicle) && Date.now() - Number(guard.startedAt || 0) < 20000) {
      return;
    }

    setSavedRestoreState(root, true);
    writeSavedRestoreGuard(vehicle);
    rememberCatalogContext(browser);

    var savedUrl = validSavedResultsUrl(vehicle.resultsUrl, browser.dataset.sfPartsCatalogMode);
    if (savedUrl) {
      window.location.replace(savedUrl);
      return;
    }

    try {
      var restored = await applyVehicleToEasySearch(vehicle, {
        submit: true,
        mode: browser.dataset.sfPartsCatalogMode
      });
      if (restored && restored.navigating) return;
    } catch (_error) {
      /* A stale EasySearch record must fall back to the normal VIN/manual UI. */
    }
    clearSavedRestoreGuard();
    setSavedRestoreState(root, false);
    paintSavedVehicle(vehicle);
  }

  function resetVehicle(root) {
    var browser = root && root.closest('[data-sf-spare-parts-browser]');
    var catalogUrl = browser && browser.dataset.sfPartsCatalogUrl;
    if (browser) browser.classList.add('is-changing-vehicle');
    if (document.body) document.body.classList.add('sf-parts-changing-vehicle');

    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (_error) {
      /* Storage may be unavailable; the visible widget can still reset. */
    }
    var selects = appSelects(root);
    selects.forEach(function (select) {
      if (select.selectedIndex > 0 || select.value) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    paintSavedVehicle(null);
    clearSavedRestoreGuard();
    setSavedRestoreState(root, false);
    document.dispatchEvent(new CustomEvent('sf:parts-vehicle-change', { detail: null }));

    if (catalogUrl && isVehicleResultsPath(window.location.pathname)) {
      try {
        var catalog = new URL(catalogUrl, window.location.origin);
        window.history.replaceState(window.history.state, '', catalog.pathname + catalog.search + catalog.hash);
      } catch (_error) {
        /* Keeping the vehicle result URL is harmless while the old results stay hidden. */
      }
    }
    localizeApp(root);
    window.requestAnimationFrame(function () {
      if (root && root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function localizeApp(root) {
    if (!root) return;
    disableEasySearchAutosubmit();
    appSelects(root).forEach(function (select, index) {
      if (index >= strings.labels.length) return;
      var holder = select.closest('.easysearch-select-holder');
      setText(holder && holder.querySelector('label'), strings.labels[index]);
      setText(select.querySelector('option[value=""]:not(.easysearch-loading-option)'), strings.placeholders[index]);
      setText(select.querySelector('.easysearch-loading-option'), strings.loading);
      select.setAttribute('aria-label', strings.labels[index]);
    });
    var submit = root.querySelector('.easysearch-btn-search, #easysearch-search, .easysearch-actions-holder button[type="submit"]');
    setText(submit, strings.submit);
    if (submit) submit.setAttribute('aria-label', strings.submit);
    root.classList.remove('is-localizing-app');
  }

  function initVehicleFilter(root) {
    if (!root || root.dataset.sfPartsVehicleReady === 'true') return;
    root.dataset.sfPartsVehicleReady = 'true';
    disableEasySearchAutosubmit();
    localizeApp(root);
    paintSavedVehicle(savedVehicle());

    var frame = 0;
    var schedule = function () {
      root.classList.add('is-localizing-app');
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        localizeApp(root);
      });
    };
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', function () {
      saveSelection(root);
      schedule();
    }, true);
    var localProductCheck = !!root.closest('[data-sf-spare-parts-product-details]');
    root.addEventListener('submit', function (event) {
      saveSelection(root);
      if (localProductCheck) {
        event.preventDefault();
        event.stopImmediatePropagation();
        checkLocalFitment(root);
      } else {
        navigatePartsResults(root, event);
      }
    }, true);
    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-sf-parts-vehicle-reset]')) {
        event.preventDefault();
        resetVehicle(root);
        return;
      }
      if (event.target.closest('[data-sf-parts-fitment-check]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        checkLocalFitment(root);
        return;
      }
      if (event.target.closest('.easysearch-btn-search, #easysearch-search, .easysearch-actions-holder button[type="submit"]')) {
        saveSelection(root);
        if (localProductCheck) {
          event.preventDefault();
          event.stopImmediatePropagation();
          checkLocalFitment(root);
        } else {
          navigatePartsResults(root, event);
        }
      }
    }, true);
  }

  function checkLocalFitment(root) {
    saveSelection(root);
    var details = root.closest('[data-sf-spare-parts-product-details]');
    if (!details) return;
    var result = details.querySelector('[data-sf-parts-fitment-result]');
    paintFitment(details, savedVehicle());
    if (result) {
      result.setAttribute('tabindex', '-1');
      result.focus({ preventScroll: true });
      result.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function initProductSearch(form) {
    if (!form || form.dataset.sfPartsProductSearchReady === 'true') return;
    form.dataset.sfPartsProductSearchReady = 'true';
    form.addEventListener('submit', function () {
      rememberCatalogContext(form);
    });
  }

  function initCategorySearch(browser) {
    var input = browser.querySelector('[data-sf-parts-category-search]');
    if (!input || input.dataset.sfPartsSearchReady === 'true') return;
    input.dataset.sfPartsSearchReady = 'true';
    var cards = Array.prototype.slice.call(browser.querySelectorAll('[data-sf-parts-category-card]'));
    var empty = browser.querySelector('[data-sf-parts-category-empty]');
    var apply = function () {
      var query = normalize(input.value);
      var shown = 0;
      cards.forEach(function (card) {
        var match = !query || normalize(card.dataset.sfPartsSearch).indexOf(query) !== -1;
        card.hidden = !match;
        if (match) shown += 1;
      });
      if (empty) empty.hidden = shown !== 0;
    };
    input.addEventListener('input', apply);
    input.addEventListener('search', apply);
  }

  function setFamilyOpen(family, open) {
    if (!family) return;
    var toggle = family.querySelector('[data-sf-parts-family-toggle]');
    var panel = family.querySelector('[data-sf-parts-family-panel]');
    family.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    if (panel) panel.hidden = !open;
  }

  function initFamilyAccordion(browser) {
    if (!browser || browser.dataset.sfPartsFamilyAccordionReady === 'true') return;
    var families = Array.prototype.slice.call(browser.querySelectorAll('[data-sf-parts-family]'));
    if (!families.length) return;
    browser.dataset.sfPartsFamilyAccordionReady = 'true';

    var selected = families.find(function (family) {
      return !!family.querySelector('[data-sf-parts-main-toggle].is-active');
    }) || families.find(function (family) {
      var toggle = family.querySelector('[data-sf-parts-family-toggle]');
      return toggle && toggle.getAttribute('aria-expanded') === 'true';
    }) || families[0];

    families.forEach(function (family) {
      setFamilyOpen(family, family === selected);
    });

    browser.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-sf-parts-family-toggle]');
      if (!toggle || !browser.contains(toggle)) return;
      event.preventDefault();
      var family = toggle.closest('[data-sf-parts-family]');
      if (!family || family.classList.contains('is-open')) return;
      families.forEach(function (candidate) {
        setFamilyOpen(candidate, candidate === family);
      });
      clearLeafSurface(browser);
      applyCatalogFilter(browser, '', '', false, '');
      window.requestAnimationFrame(function () {
        toggle.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function canonicalMainCategory(value) {
    var normalized = String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^sf-main-/, '')
      .replace(/-/g, '_');
    var aliases = {
      transmission: 'transmission_differential',
      differential: 'transmission_differential',
      air_conditioning: 'ac',
      electrical: 'electrical_parts',
      body: 'body_accessories'
    };
    return aliases[normalized] || normalized;
  }

  function canonicalLeafCategory(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/^sf-part-/, '')
      .replace(/[\s-]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  function consumablesCardSelection(card) {
    if (!card) return null;
    var key = canonicalLeafCategory(card.dataset.sfConsumablesFilter);
    var tag = String(card.dataset.sfConsumablesTag || '').trim();
    if (!key || !tag) return null;
    return {
      key: key,
      tag: tag,
      label: String(card.dataset.sfConsumablesLabel || '').trim(),
      collectionHandle: String(card.dataset.sfConsumablesCollection || '').trim()
    };
  }

  function consumablesPathTag(value) {
    var context = vehicleResultsContext(value);
    return context && context.mode === 'collection' ? context.categoryTag : '';
  }

  function productMatchesConsumable(item, selection) {
    if (!item || !selection) return false;
    var rawTags = String(item.dataset.sfProductTags || item.dataset.fitmentTags || '')
      .split('||')
      .filter(Boolean);
    var wantedTag = normalize(selection.tag);
    if (rawTags.some(function (tag) { return normalize(tag) === wantedTag; })) return true;

    var haystack = normalize([
      item.dataset.sfProductTitle,
      item.dataset.sfProductInfo,
      item.dataset.sfPartType,
      item.dataset.sfSubcategory,
      item.dataset.sfPartKey,
      item.textContent
    ].join(' '));
    var patterns = {
      engine_oil_filter: /(?:engine oil filter|oil filter|فلتر الزيت|فلتر زيت)/i,
      engine_air_filter: /(?:engine air filter|air cleaner filter|فلتر الهواء|فلتر هواء)/i,
      cabin_filter: /(?:cabin air filter|cabin filter|a c filter|pollen filter|فلتر المكيف|فلتر مكيف)/i,
      spark_plug: /(?:spark plug|بواجي|بوجي)/i,
      front_brake_pad: /(?:front brake pad|front ceramic brake|سفايف امامية|سفايف أمامية)/i,
      rear_brake_pad: /(?:rear brake pad|rear ceramic brake|سفايف خلفية)/i,
      transmission_filter: /(?:transmission filter|gear filter|فلتر الجير|فلتر القير|فلتر جير|فلتر قير)/i
    };
    if (selection.key === 'engine_oil_filter' && /(?:transmission|gear|جير|قير)/i.test(haystack)) return false;
    if (selection.key === 'engine_air_filter' && /(?:cabin|a c|مكيف|تكييف)/i.test(haystack)) return false;
    return Boolean(patterns[selection.key] && patterns[selection.key].test(haystack));
  }

  function paintConsumablesCards(browser, selection) {
    browser.querySelectorAll('[data-sf-consumables-card]').forEach(function (card) {
      var candidate = consumablesCardSelection(card);
      var active = Boolean(selection && candidate && candidate.key === selection.key);
      card.classList.toggle('is-active', active);
      card.setAttribute('aria-pressed', String(active));
      if (active) card.setAttribute('aria-current', 'page');
      else card.removeAttribute('aria-current');
    });
    browser.dataset.sfConsumablesSelected = selection ? selection.key : '';
    var status = browser.querySelector('[data-sf-consumables-current]');
    if (status) {
      status.hidden = !selection;
      status.textContent = selection
        ? (AR ? 'القسم المختار: ' : 'Selected category: ') + selection.label
        : '';
    }
  }

  function filterVinConsumables(browser, selection) {
    if (!browser || !selection || !browser.classList.contains('is-vin-results-active')) return false;
    var items = Array.prototype.slice.call(browser.querySelectorAll('[data-sf-vin-product]'));
    if (!items.length) return false;
    var matched = 0;
    items.forEach(function (item) {
      var visible = productMatchesConsumable(item, selection);
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
      if (visible) matched += 1;
    });
    var count = browser.querySelector('[data-sf-vin-result-count]');
    if (count) count.textContent = AR ? matched + ' منتج' : matched + (matched === 1 ? ' product' : ' products');
    var empty = browser.querySelector('[data-sf-vin-empty]');
    if (empty) empty.hidden = matched > 0;
    return true;
  }

  function filterCatalogConsumables(browser, selection, shouldScroll) {
    if (!browser || !selection) return false;
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-sf-spare-parts-product]'));
    if (!items.length) return false;
    var matched = 0;

    items.forEach(function (item) {
      var visible = productMatchesConsumable(item, selection);
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
      if (visible) matched += 1;
    });

    updateCatalogProductCounts(matched);
    var empty = document.querySelector('[data-sf-parts-local-empty]');
    if (empty) empty.hidden = matched > 0;
    var results = document.querySelector('[data-sf-spare-parts-results]');
    if (results) {
      results.classList.remove('is-catalog-loading', 'is-consumables-awaiting-category');
    }
    if (document.body) document.body.classList.remove('sf-consumables-awaiting-category');
    if (shouldScroll !== false) scrollToCatalogResults();
    return true;
  }

  function refreshConsumablesCatalog(browser) {
    if (!browser || browser.dataset.sfPartsCatalogMode !== 'consumables') return;
    document.body && document.body.classList.add('sf-consumables-page');
    var landing = browser.dataset.sfConsumablesLanding === 'true' && !isVehicleResultsPath(window.location.pathname);
    if (landing) writeConsumablesSelection(null);

    var liquidKey = canonicalLeafCategory(browser.dataset.sfConsumablesSelected);
    var selectedCard = liquidKey
      ? browser.querySelector('[data-sf-consumables-filter="' + liquidKey.replace(/"/g, '\\"') + '"]')
      : null;
    var selection = consumablesCardSelection(selectedCard);
    if (!selection && !landing) selection = readConsumablesSelection();
    if (selection) writeConsumablesSelection(selection);

    var vehicleContext = vehicleResultsContext(window.location.href);
    if (vehicleContext) {
      var canonicalUrl = consumablesVehicleUrl(window.location.href, '', '');
      var currentUrl = window.location.pathname + window.location.search;
      var nextUrl = canonicalUrl.pathname + canonicalUrl.search;
      if (nextUrl !== currentUrl) {
        window.location.replace(nextUrl);
        return;
      }
    }

    paintConsumablesCards(browser, selection);
    if (selection) {
      if (browser.classList.contains('is-vin-results-active')) {
        filterVinConsumables(browser, selection);
      } else if (vehicleContext) {
        var shouldScroll = consumablesResultsScrollRequested();
        var filtered = filterCatalogConsumables(browser, selection, shouldScroll);
        if (filtered && shouldScroll) clearConsumablesResultsScrollRequest();
      }
    }
    var results = document.querySelector('[data-sf-spare-parts-results]');
    var awaiting = !selection;
    if (results) results.classList.toggle('is-consumables-awaiting-category', awaiting);
    if (document.body) document.body.classList.toggle('sf-consumables-awaiting-category', awaiting);
  }

  function initConsumablesCatalog(browser) {
    if (!browser || browser.dataset.sfPartsCatalogMode !== 'consumables') return;
    if (browser.dataset.sfConsumablesReady !== 'true') {
      browser.dataset.sfConsumablesReady = 'true';
      browser.addEventListener('click', function (event) {
        var card = event.target.closest('[data-sf-consumables-card]');
        if (!card || !browser.contains(card)) return;
        var selection = consumablesCardSelection(card);
        if (!selection) return;

        var directVin = browser.classList.contains('is-vin-results-active');
        var vehicleResults = isVehicleResultsPath(window.location.pathname);
        var vehicle = !directVin && !vehicleResults ? savedVehicle() : null;
        var savedTarget = vehicle
          ? validSavedResultsUrl(vehicle.resultsUrl, 'consumables')
          : '';

        if (!directVin && !vehicleResults) requestConsumablesResultsScroll();

        if (directVin || vehicleResults || savedTarget) {
          event.preventDefault();
          event.stopImmediatePropagation();
          writeConsumablesSelection(selection);
          rememberCatalogContext(browser);
          paintConsumablesCards(browser, selection);

          if (savedTarget) {
            window.location.assign(savedTarget);
            return;
          }

          var results = document.querySelector('[data-sf-spare-parts-results]');
          if (results) results.classList.remove('is-consumables-awaiting-category');
          if (document.body) document.body.classList.remove('sf-consumables-awaiting-category');

          if (directVin) {
            filterVinConsumables(browser, selection);
            scrollToCatalogResults();
          } else {
            filterCatalogConsumables(browser, selection, true);
          }
          return;
        }

        writeConsumablesSelection(selection);
        rememberCatalogContext(browser);
      });
    }
    refreshConsumablesCatalog(browser);
  }

  function categoryImageUrl(key) {
    return CATEGORY_IMAGE_URLS[canonicalLeafCategory(key)] || '';
  }

  function applyCategoryImageOverride(card, key, mediaSelector, width, height) {
    if (!card || !key) return false;
    var normalizedKey = canonicalLeafCategory(key);
    var url = categoryImageUrl(normalizedKey);
    if (!url || card.dataset.sfCategoryImageFailed === normalizedKey) return false;
    var media = card.querySelector(mediaSelector);
    if (!media) return false;
    if (media.dataset.sfCategoryImageUrl === url && media.querySelector('img')) return true;

    if (!categoryImageFallbacks.has(media)) categoryImageFallbacks.set(media, media.innerHTML);
    var image = document.createElement('img');
    image.src = url;
    image.alt = '';
    image.width = width;
    image.height = height;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.addEventListener('load', function () {
      card.classList.add('has-curated-category-image');
    }, { once: true });
    image.addEventListener('error', function () {
      if (media.dataset.sfCategoryImageUrl !== url) return;
      media.innerHTML = categoryImageFallbacks.get(media) || '';
      media.removeAttribute('data-sf-category-image-url');
      card.dataset.sfCategoryImageFailed = normalizedKey;
      card.classList.remove('has-curated-category-image');
      window.requestAnimationFrame(function () {
        var browser = card.closest('[data-sf-spare-parts-browser]');
        if (browser) syncLeafAvailability(browser);
      });
    }, { once: true });
    media.innerHTML = '';
    media.dataset.sfCategoryImageUrl = url;
    media.appendChild(image);
    return true;
  }

  function applyCategoryImageOverrides(browser) {
    if (!browser) return;
    browser.querySelectorAll('[data-sf-parts-main-toggle]').forEach(function (card) {
      applyCategoryImageOverride(card, card.dataset.sfPartsMainFilter, '.sf-parts-family__sub-media', 120, 120);
    });
    browser.querySelectorAll('[data-sf-parts-leaf-filter]').forEach(function (card) {
      applyCategoryImageOverride(card, card.dataset.sfPartsLeafFilter, '.sf-spare-parts-sub-card__media', 96, 96);
    });
  }

  function productLeafCategories(item) {
    if (!item) return [];
    var keys = new Set();
    String(item.dataset.sfProductTags || item.dataset.fitmentTags || '')
      .split(/\|\||,/)
      .forEach(function (tag) {
        tag = String(tag || '').trim();
        if (!/^sf-part-/i.test(tag)) return;
        var key = canonicalLeafCategory(tag);
        if (key) keys.add(key);
      });
    [item.dataset.sfPartType, item.dataset.sfSubcategory, item.dataset.sfPartKey]
      .forEach(function (value) {
        String(value || '').split(/\|\||,/).forEach(function (candidate) {
          var key = canonicalLeafCategory(candidate);
          if (key) keys.add(key);
        });
      });
    return Array.from(keys);
  }

  function productMatchesLeafCategory(item, key) {
    key = canonicalLeafCategory(key);
    return !key || productLeafCategories(item).indexOf(key) !== -1;
  }

  function productMatchesMainCategory(item, key) {
    if (!item || !key) return true;
    var tags = String(item.dataset.sfProductTags || item.dataset.fitmentTags || '').split('||');
    var explicitTags = tags.filter(function (tag) {
      return /^sf-main-/i.test(String(tag || '').trim());
    });
    if (explicitTags.length) {
      return explicitTags.some(function (tag) { return canonicalMainCategory(tag) === key; });
    }

    var explicitMain = canonicalMainCategory(item.dataset.sfMainCategory);
    if (explicitMain) return explicitMain === key;

    var haystack = normalize([
      item.dataset.sfProductInfo,
      item.dataset.sfPartType,
      item.dataset.sfSubcategory,
      item.textContent
    ].join(' '));
    var fallbackPatterns = {
      engine: /(?:engine mount|motor mount|spark plug|ignition coil|timing|piston|crankshaft|connecting rod|oil pump|belt tensioner|idler pulley|alternator pulley|محرك|مكينه|مكينة|قاعدة محرك|بواجي|كويل|تايمن|بكرة|شداد)/i,
      cooling: /(?:cooling|radiator|thermostat|water pump|coolant hose|fan shroud|تبريد|راديتر|رديتر|ثرموستات|طرمبه ماء|طرمبة ماء|خرطوم تبريد)/i,
      fuel_air: /(?:fuel injector|fuel pump|throttle body|intake manifold|air intake|air cleaner|بخاخ|طرمبة وقود|مضخة وقود|ثروتل|مانيفولد|سحب الهواء)/i,
      exhaust: /(?:exhaust pipe|muffler|catalytic|exhaust hardware|عادم|شكمان|دبة تلوث)/i,
      brakes: /(?:brake pad|brake disc|brake rotor|caliper|parking brake|فرامل|سفايف|هوب فرامل)/i,
      suspension_steering: /(?:suspension|steering|shock absorber|control arm|tie rod|wheel hub|wheel bearing|تعليق|دركسون|مقص|مساعد|رولمان عجل)/i,
      electrical_sensors: /(?:oxygen sensor|air fuel ratio sensor|maf sensor|knock sensor|crankshaft sensor|camshaft sensor|abs sensor|حساس اكسجين|حساس هواء|حساس طرق|حساس كرنك|حساس كام|حساس abs)/i,
      electrical_parts: /(?:alternator|starter motor|starter assembly|relay|electric motor|horn|lamp|fuse|switch|antenna|دينمو|سلف|ريليه|بوق|لمبة|فيوز|سويتش|انتينا)/i,
      ac: /(?:air conditioning|ac compressor|compressor sensor|evaporator|condenser|hvac|blower|thermistor|مكيف|كمبريسر|كمبروسر|ثلاجة مكيف|كوندنسر|منفاخ)/i,
      body_accessories: /(?:body trim|wiper|mirror|bumper|door handle|exterior|مساحه|مساحة|مرايه|مراية|صدام|مقبض|قطعة خارجية)/i,
      transmission_differential: /(?:transmission mount|transmission filter|transmission gasket|gearbox|differential|clutch release|transfer case|جير|قير|دفرنس|كلتش)/i,
      drivetrain: /(?:drivetrain|drive shaft|propeller shaft|axle shaft|cv axle|cv joint|universal joint|u joint|عكس|صليبه|صليبة|عمود دوران)/i
    };
    return !!fallbackPatterns[key] && fallbackPatterns[key].test(haystack);
  }

  var catalogStates = new WeakMap();
  var catalogFilterRequest = 0;
  var leafRailStates = new WeakMap();
  var leafRailRequest = 0;

  function resultTotal(results) {
    var marker = results && results.querySelector('[data-sf-parts-result-total]');
    return Number(marker && marker.dataset.sfPartsResultTotal) || 0;
  }

  function catalogState(browser) {
    var results = document.querySelector('[data-sf-spare-parts-results]');
    if (!results) return null;
    if (catalogStates.has(browser)) return catalogStates.get(browser);
    var state = {
      /* Always build tag-filter requests from the all-products catalogue route.
         This keeps future tagged products discoverable even when this section is
         rendered from a custom collection URL. */
      baseUrl: (browser.dataset.sfPartsCatalogUrl || window.location.href).replace(/#.*$/, ''),
      base: { html: results.innerHTML, total: resultTotal(results) },
      fallbackItems: Array.prototype.map.call(
        results.querySelectorAll('[data-sf-spare-parts-product]'),
        function (item) { return item.outerHTML; }
      ),
      cache: new Map()
    };
    catalogStates.set(browser, state);
    return state;
  }

  function categoryServerTag(key) {
    return 'sf-main-' + canonicalMainCategory(key).replace(/_/g, '-');
  }

  function subcategoryServerTag(key) {
    return 'sf-part-' + canonicalLeafCategory(key).replace(/_/g, '-');
  }

  function categoryRequestUrl(baseUrl, key, leaf) {
    var url = new URL(baseUrl, window.location.origin);
    var parts = decodeURIComponent(url.pathname).split('/').filter(Boolean);
    var collectionsIndex = parts.indexOf('collections');
    if (collectionsIndex !== -1 && parts[collectionsIndex + 1] === 'all') {
      var tagIndex = collectionsIndex + 2;
      var tags = tagIndex < parts.length ? parts[tagIndex].split('+') : [];
      tags = tags.filter(function (tag) {
        var clean = normalize(tag);
        return clean &&
          !/^sf main /i.test(clean) &&
          !/^sf part /i.test(clean) &&
          clean !== 'sf department spare parts' &&
          clean !== 'القسم قطع غيار';
      });
      if (key) tags.push(categoryServerTag(key));
      if (leaf) tags.push(subcategoryServerTag(leaf));
      parts = parts.slice(0, tagIndex);
      if (tags.length) parts.push(tags.join('+'));
      url.pathname = '/' + parts.join('/');
    }
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.set('view', 'senfineco-spare-parts');
    url.hash = '';
    return url;
  }

  function mergeFallbackItems(container, state, key, leaf) {
    var grid = container.querySelector('#product-grid');
    if (!grid) return 0;
    var known = new Set(Array.prototype.map.call(grid.querySelectorAll('[data-sf-product-id]'), function (item) {
      return item.dataset.sfProductId;
    }));
    var added = 0;
    state.fallbackItems.forEach(function (html) {
      var parsed = new DOMParser().parseFromString('<ul>' + html + '</ul>', 'text/html');
      var item = parsed.querySelector('[data-sf-spare-parts-product]');
      if (!item || !productMatchesMainCategory(item, key) || !productMatchesLeafCategory(item, leaf)) return;
      var id = item.dataset.sfProductId || '';
      if (id && known.has(id)) return;
      if (id) known.add(id);
      grid.appendChild(document.importNode(item, true));
      added += 1;
    });
    if (added > 0) {
      var emptyInner = grid.querySelector(':scope > .collection-empty__inner');
      if (emptyInner) emptyInner.remove();
      grid.querySelectorAll(':scope > .loading-overlay').forEach(function (overlay) { overlay.remove(); });
      grid.classList.remove('collection-empty', 'collection-empty--filtered', 'collection-empty--initial');
      grid.classList.add('product-grid', 'grid-flex', 'list-unstyled');
      grid.setAttribute('role', 'list');
    }
    return added;
  }

  async function fetchCatalogView(browser, key, leaf) {
    var state = catalogState(browser);
    var results = document.querySelector('[data-sf-spare-parts-results]');
    if (!state || !results) throw new Error('catalog state');
    if (!key && !leaf) return state.base;
    var cacheKey = canonicalMainCategory(key) + '::' + canonicalLeafCategory(leaf);
    if (state.cache.has(cacheKey)) return state.cache.get(cacheKey);

    var currentGrid = results.querySelector('#product-grid');
    var sectionId = currentGrid && currentGrid.dataset.id;
    if (!sectionId) throw new Error('catalog section');
    var url = categoryRequestUrl(state.baseUrl, key, leaf);
    url.searchParams.set('section_id', sectionId);
    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('catalog category ' + cacheKey);
    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fetched = parsed.querySelector('[data-sf-spare-parts-results]');
    if (!fetched) throw new Error('catalog result ' + cacheKey);
    var total = resultTotal(fetched);
    total += mergeFallbackItems(fetched, state, key, leaf);
    var marker = fetched.querySelector('[data-sf-parts-result-total]');
    if (marker) marker.dataset.sfPartsResultTotal = String(total);
    var payload = { html: fetched.innerHTML, total: total };
    state.cache.set(cacheKey, payload);
    return payload;
  }

  function leafRailState(browser) {
    if (leafRailStates.has(browser)) return leafRailStates.get(browser);
    var state = { activeKey: '', cache: new Map() };
    leafRailStates.set(browser, state);
    return state;
  }

  function browserSectionId(browser) {
    var wrapper = browser && browser.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace(/^shopify-section-/, '') : '';
  }

  async function requestLeafCards(url) {
    var response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('subcategory rail ' + response.status);
    var html = await response.text();
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var rail = parsed.querySelector('.sf-spare-parts-sub-grid');
    if (!rail) return null;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sf-parts-leaf-filter]'));
    if (!cards.length) return null;
    return cards.map(function (card) { return card.outerHTML; }).join('');
  }

  async function fetchLeafCards(browser, branch, key) {
    var state = leafRailState(browser);
    var cacheKey = canonicalMainCategory(key) + '::' + (document.documentElement.lang || '');
    if (state.cache.has(cacheKey)) return state.cache.get(cacheKey);

    var url = new URL(branch.href, window.location.origin);
    url.hash = '';
    url.searchParams.set('view', 'senfineco-spare-parts');
    var fullUrl = new URL(url.toString());
    var sectionId = browserSectionId(browser);
    if (sectionId) url.searchParams.set('section_id', sectionId);

    var html = await requestLeafCards(url);
    if (!html && sectionId) html = await requestLeafCards(fullUrl);
    if (!html) throw new Error('subcategory rail ' + cacheKey);
    state.cache.set(cacheKey, html);
    return html;
  }

  function installLeafCards(browser, html, key) {
    var rail = browser.querySelector('[data-sf-parts-leaf-rail]');
    if (!rail) return [];
    rail.innerHTML = html;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sf-parts-leaf-filter]'));
    cards.forEach(function (card) {
      card.classList.remove('is-active', 'is-unavailable', 'is-vehicle-unavailable');
      card.hidden = false;
      card.removeAttribute('aria-disabled');
      card.setAttribute('aria-pressed', 'false');
      card.setAttribute('aria-controls', 'product-grid');
      if (!card.dataset.sfPartsMainFilter) card.dataset.sfPartsMainFilter = key;
      applyCategoryImageOverride(card, card.dataset.sfPartsLeafFilter, '.sf-spare-parts-sub-card__media', 96, 96);
    });
    return cards;
  }

  function syncLeafAvailability(browser) {
    var surface = browser.querySelector('[data-sf-parts-leaf-surface]');
    var rail = browser.querySelector('[data-sf-parts-leaf-rail]');
    var empty = browser.querySelector('[data-sf-parts-leaf-empty]');
    if (!surface || !rail) return;
    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-sf-parts-leaf-filter]'));
    if (!cards.length) {
      if (empty) empty.hidden = false;
      return;
    }

    var directVin = browser.classList.contains('is-vin-results-active');
    var items = Array.prototype.slice.call(document.querySelectorAll(
      directVin ? '[data-sf-vin-product]' : '[data-sf-spare-parts-product]'
    ));
    cards.forEach(function (card) {
      var key = canonicalLeafCategory(card.dataset.sfPartsLeafFilter);
      var matchingItems = items.filter(function (item) { return productMatchesLeafCategory(item, key); });
      applyCategoryImageOverride(card, key, '.sf-spare-parts-sub-card__media', 96, 96);
      if (!card.querySelector('img')) {
        var sourceItem = matchingItems.find(function (item) {
          return item.dataset.sfProductImage || item.querySelector('img');
        });
        var sourceImage = sourceItem && sourceItem.querySelector('img');
        var imageUrl = sourceItem && (sourceItem.dataset.sfProductImage || (sourceImage && (sourceImage.currentSrc || sourceImage.src)));
        var media = card.querySelector('.sf-spare-parts-sub-card__media');
        if (imageUrl && media) {
          var image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.width = 96;
          image.height = 96;
          image.loading = 'lazy';
          media.innerHTML = '';
          media.appendChild(image);
          card.classList.add('has-product-image');
        }
      }
      /* Categories are permanent catalogue destinations. Keep every leaf visible
         even before it has products; future sf-main-* + sf-part-* tags populate it. */
      card.hidden = false;
      card.classList.remove('is-unavailable', 'is-vehicle-unavailable');
      card.removeAttribute('aria-disabled');
    });

    if (empty) empty.hidden = true;
    rail.hidden = false;
  }

  function clearLeafSurface(browser) {
    if (!browser) return;
    var leafState = leafRailStates.get(browser);
    if (leafState) leafState.activeKey = '';
    leafRailRequest += 1;
    var surface = browser.querySelector('[data-sf-parts-leaf-surface]');
    var rail = browser.querySelector('[data-sf-parts-leaf-rail]');
    var status = browser.querySelector('[data-sf-parts-leaf-status]');
    var empty = browser.querySelector('[data-sf-parts-leaf-empty]');
    if (surface) {
      surface.hidden = true;
      surface.removeAttribute('aria-busy');
    }
    if (rail) {
      rail.innerHTML = '';
      rail.hidden = false;
    }
    if (status) {
      status.textContent = '';
      status.classList.remove('is-loading');
    }
    if (empty) empty.hidden = true;
    browser.querySelectorAll('[data-sf-parts-main-toggle]').forEach(function (branch) {
      branch.classList.remove('is-active');
      branch.setAttribute('aria-expanded', 'false');
    });
    browser.dataset.sfActivePartsMain = '';
    browser.dataset.sfActivePartsLeaf = '';
  }

  function revealLeafSurface(surface) {
    if (!surface) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var viewport = window.visualViewport;
        var safeTop = viewport ? viewport.offsetTop : 0;
        var safeBottom = safeTop + (viewport ? viewport.height : window.innerHeight);

        document.querySelectorAll('sticky-header, header-component, [data-sticky-header], .shopify-section-group-header-group').forEach(function (node) {
          var style = window.getComputedStyle(node);
          var box = node.getBoundingClientRect();
          if ((style.position === 'fixed' || style.position === 'sticky') && box.top <= safeTop + 2 && box.bottom > safeTop && box.height < window.innerHeight * 0.4) {
            safeTop = Math.max(safeTop, box.bottom);
          }
        });
        document.querySelectorAll('#preview-bar-iframe, .shopify-preview-bar, [data-shopify-preview-bar]').forEach(function (node) {
          var box = node.getBoundingClientRect();
          if (box.height > 0 && box.top > safeTop) safeBottom = Math.min(safeBottom, box.top);
        });

        safeTop += 10;
        safeBottom -= 14;
        var box = surface.getBoundingClientRect();
        var available = safeBottom - safeTop;
        var preferredInset = Math.max(112, Math.min(220, available * 0.34));
        var preferredTop = safeTop + preferredInset;
        var delta = 0;
        if (box.height > available) delta = box.top - safeTop;
        else if (box.top > preferredTop) delta = box.top - preferredTop;
        else if (box.bottom > safeBottom) delta = box.bottom - safeBottom;
        else if (box.top < safeTop) delta = box.top - safeTop;
        if (Math.abs(delta) > 2) window.scrollBy({ top: delta, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
  }

  async function showLeafSurface(browser, branch) {
    if (!browser || !branch) return;
    var key = canonicalMainCategory(branch.dataset.sfPartsMainFilter);
    var label = branch.dataset.sfPartsMainLabel || '';
    var surface = browser.querySelector('[data-sf-parts-leaf-surface]');
    var title = browser.querySelector('[data-sf-parts-leaf-title]');
    var rail = browser.querySelector('[data-sf-parts-leaf-rail]');
    var status = browser.querySelector('[data-sf-parts-leaf-status]');
    var empty = browser.querySelector('[data-sf-parts-leaf-empty]');
    if (!key || !surface || !rail) return;

    var state = leafRailState(browser);
    var requestId = ++leafRailRequest;
    state.activeKey = key;
    browser.dataset.sfActivePartsMain = key;
    browser.dataset.sfActivePartsLeaf = '';
    surface.hidden = false;
    surface.setAttribute('aria-busy', 'true');
    if (title) title.textContent = label;
    if (empty) empty.hidden = true;
    rail.hidden = false;
    browser.querySelectorAll('[data-sf-parts-main-toggle]').forEach(function (candidate) {
      var active = candidate === branch;
      candidate.classList.toggle('is-active', active);
      candidate.setAttribute('aria-expanded', String(active));
    });
    revealLeafSurface(surface);

    var cacheKey = key + '::' + (document.documentElement.lang || '');
    if (!state.cache.has(cacheKey)) {
      rail.innerHTML = '';
      if (status) {
        status.textContent = AR ? 'جاري تحميل التصنيفات الفرعية…' : 'Loading subcategories…';
        status.classList.add('is-loading');
      }
    }

    var filterPromise = applyCatalogFilter(browser, key, '', false, label, branch.href);
    try {
      var html = await fetchLeafCards(browser, branch, key);
      if (requestId !== leafRailRequest || state.activeKey !== key) return;
      installLeafCards(browser, html, key);
      await filterPromise;
      if (requestId !== leafRailRequest || state.activeKey !== key) return;
      syncLeafAvailability(browser);
      revealLeafSurface(surface);
      if (status) status.textContent = '';
    } catch (error) {
      console.error('[SF Parts] subcategory rail error', error);
      if (requestId !== leafRailRequest || state.activeKey !== key) return;
      rail.innerHTML = '';
      if (empty) empty.hidden = false;
      if (status) status.textContent = AR ? 'تعذّر تحميل التصنيفات الآن.' : 'Subcategories could not be loaded.';
    } finally {
      if (requestId === leafRailRequest && state.activeKey === key) {
        surface.removeAttribute('aria-busy');
        if (status) status.classList.remove('is-loading');
      }
    }
  }

  function updateCatalogProductCounts(total) {
    ['ProductCountDesktop', 'ProductCountMobileSummary'].forEach(function (id) {
      var counter = document.getElementById(id);
      if (!counter) return;
      var text = counter.textContent || '';
      counter.textContent = /\d+/.test(text)
        ? text.replace(/\d+/, String(total))
        : (AR ? total + ' منتج متوافق' : total + (total === 1 ? ' compatible product' : ' compatible products'));
    });
  }

  function installCatalogView(results, payload, key) {
    if (!results || !payload) return;
    if (results.dataset.sfCatalogView === key) return;
    results.innerHTML = payload.html;
    results.dataset.sfCatalogView = key;
    updateCatalogProductCounts(payload.total);
    boot(results);
  }

  function paintCatalogFilterChrome(browser, key, leaf, label, total) {
    key = canonicalMainCategory(key);
    leaf = canonicalLeafCategory(leaf);
    browser.dataset.sfActivePartsFilter = key;
    browser.dataset.sfActivePartsMain = key;
    browser.dataset.sfActivePartsLeaf = leaf;
    if (key && label) browser.dataset.sfActivePartsFilterLabel = label;
    if (!key) browser.dataset.sfActivePartsFilterLabel = '';
    browser.querySelectorAll('[data-sf-parts-main-toggle]').forEach(function (button) {
      var active = !!key && canonicalMainCategory(button.dataset.sfPartsMainFilter) === key;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-expanded', String(active));
    });
    browser.querySelectorAll('[data-sf-parts-leaf-filter]').forEach(function (button) {
      var active = !!leaf && canonicalLeafCategory(button.dataset.sfPartsLeafFilter) === leaf;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    browser.dataset.sfActivePartsTotal = String(Number(total) || 0);
  }

  function scrollToCatalogResults() {
    var results = document.querySelector('[data-sf-spare-parts-results]');
    if (!results) return;
    results.setAttribute('tabindex', '-1');
    window.requestAnimationFrame(function () {
      results.focus({ preventScroll: true });
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function renderCatalogFilter(browser, key, leaf, shouldScroll, label) {
    if (!browser) return false;
    key = canonicalMainCategory(key);
    leaf = canonicalLeafCategory(leaf);
    if (key && !label) label = browser.dataset.sfActivePartsFilterLabel || '';
    var directVin = browser.classList.contains('is-vin-results-active');
    var items = Array.prototype.slice.call(document.querySelectorAll(
      directVin ? '[data-sf-vin-product]' : '[data-sf-spare-parts-product]'
    ));
    if (!items.length) return false;
    var matched = 0;
    items.forEach(function (item) {
      var visible = (!key || productMatchesMainCategory(item, key)) &&
        (!leaf || productMatchesLeafCategory(item, leaf));
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
      if (visible) matched += 1;
    });

    paintCatalogFilterChrome(browser, key, leaf, label, matched);
    updateCatalogProductCounts(matched);
    var empty = document.querySelector('[data-sf-parts-local-empty]');
    if (empty) empty.hidden = !key || matched > 0;

    if (shouldScroll !== false) scrollToCatalogResults();
    return true;
  }

  async function applyCatalogFilter(browser, key, leaf, shouldScroll, label) {
    if (!browser) return false;
    key = canonicalMainCategory(key);
    leaf = canonicalLeafCategory(leaf);
    var requestKey = key + '::' + leaf;
    var requestId = ++catalogFilterRequest;
    browser.dataset.sfRequestedPartsFilter = requestKey;
    var results = document.querySelector('[data-sf-spare-parts-results]');

    /* EasySearch result routes already contain the vehicle-compatible set.
       Canonicalize stale narrow consumables URLs before drilling into spare parts. */
    var vehicleContext = vehicleResultsContext(window.location.href);
    if (
      activePartsView() === 'senfineco-spare-parts' &&
      vehicleContext &&
      (
        vehicleContext.mode !== 'tag' ||
        vehicleContext.collectionHandle !== 'all' ||
        vehicleContext.categoryTag
      )
    ) {
      var canonicalVehicleUrl = validSavedResultsUrl(window.location.href);
      if (canonicalVehicleUrl && canonicalVehicleUrl !== window.location.pathname + window.location.search) {
        window.location.replace(canonicalVehicleUrl);
        return false;
      }
    }
    if (browser.classList.contains('is-vin-results-active') || vehicleContext) {
      return renderCatalogFilter(browser, key, leaf, shouldScroll, label);
    }

    if (key || leaf || catalogStates.has(browser)) {
      browser.setAttribute('aria-busy', 'true');
      if (results) results.classList.add('is-catalog-loading');
      try {
        var payload = await fetchCatalogView(browser, key, leaf);
        if (requestId !== catalogFilterRequest || browser.dataset.sfRequestedPartsFilter !== requestKey) return false;
        installCatalogView(results, payload, requestKey || 'base');
        paintCatalogFilterChrome(browser, key, leaf, label, payload.total);
        if (shouldScroll !== false) scrollToCatalogResults();
        return true;
      } catch (error) {
        console.error('[SF Parts] catalog category error', error);
        if (requestId !== catalogFilterRequest || browser.dataset.sfRequestedPartsFilter !== requestKey) return false;
        browser.dataset.sfPartsCatalogError = 'true';
        return renderCatalogFilter(browser, key, leaf, shouldScroll, label);
      } finally {
        if (requestId === catalogFilterRequest) {
          browser.removeAttribute('aria-busy');
          if (results) results.classList.remove('is-catalog-loading');
        }
      }
    }

    return renderCatalogFilter(browser, key, leaf, shouldScroll, label);
  }

  function initCatalogFilters(browser) {
    if (!browser || browser.dataset.sfPartsCatalogFiltersReady === 'true') return;
    browser.dataset.sfPartsCatalogFiltersReady = 'true';
    browser.addEventListener('click', function (event) {
      var leaf = event.target.closest('[data-sf-parts-leaf-filter]');
      if (leaf && browser.contains(leaf)) {
        event.preventDefault();
        var mainKey = canonicalMainCategory(leaf.dataset.sfPartsMainFilter || browser.dataset.sfActivePartsMain);
        var leafKey = canonicalLeafCategory(leaf.dataset.sfPartsLeafFilter);
        applyCatalogFilter(browser, mainKey, leafKey, true, leaf.dataset.sfPartsLeafLabel || '', leaf.href);
        return;
      }

      var branch = event.target.closest('[data-sf-parts-main-toggle]');
      if (branch && browser.contains(branch)) {
        event.preventDefault();
        showLeafSurface(browser, branch);
        return;
      }

      if (event.target.closest('[data-sf-parts-main-show-all]')) {
        event.preventDefault();
        var activeMain = canonicalMainCategory(browser.dataset.sfActivePartsMain);
        var activeLabel = browser.querySelector('[data-sf-parts-leaf-title]');
        applyCatalogFilter(browser, activeMain, '', true, activeLabel ? activeLabel.textContent : '', '');
        return;
      }

      var filter = event.target.closest('[data-sf-parts-filter]');
      if (filter) {
        event.preventDefault();
        var key = canonicalMainCategory(filter.dataset.sfPartsFilter);
        var active = canonicalMainCategory(browser.dataset.sfActivePartsFilter);
        var next = active === key ? '' : key;
        applyCatalogFilter(browser, next, '', true, filter.dataset.sfPartsLabel || '', filter.href);
        return;
      }
      if (event.target.closest('[data-sf-parts-filter-clear]')) {
        event.preventDefault();
        clearLeafSurface(browser);
        applyCatalogFilter(browser, '', '', true, '');
      }
    });
  }

  function favoriteSet() {
    var values = readStorage(FAVORITES_KEY, []);
    return new Set(Array.isArray(values) ? values : []);
  }

  function saveFavoriteSet(set) {
    writeStorage(FAVORITES_KEY, Array.from(set));
  }

  function heartMarkup() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2 4.7 13A5.1 5.1 0 0 1 12 5.9 5.1 5.1 0 0 1 19.3 13L12 20.2Z"/></svg>';
  }

  function hydrateQuickAdd(item, card) {
    var cartForm = card && card.querySelector('form[data-sf-grid-cart], form.sf-grid-cart-form, form.sf-parts-card__cart-form');
    if (!cartForm) return;
    var variantInput = cartForm.querySelector('input[name="id"]');
    var quantityInput = cartForm.querySelector('input[name="quantity"]');
    var cartButton = cartForm.querySelector('button[type="submit"]');
    var variantId = String(item.dataset.sfProductVariantId || item.dataset.sfVariantId || '').replace(/\D+/g, '');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.setAttribute('value', variantId);
    }
    if (quantityInput) {
      quantityInput.value = '1';
      quantityInput.setAttribute('value', '1');
    }
    if (cartButton) {
      var enabled = Boolean(variantId) && item.dataset.sfProductAvailable !== 'false';
      cartButton.disabled = !enabled;
      if (enabled) cartButton.removeAttribute('aria-disabled');
      else cartButton.setAttribute('aria-disabled', 'true');
    }
  }

  function hydrateQuickAddFromControl(control) {
    var item = control && control.closest('[data-sf-spare-parts-product]');
    var card = item && item.querySelector('.product-card');
    if (item && card) hydrateQuickAdd(item, card);
  }

  function enhanceProductItem(item) {
    if (!item) return;
    var card = item.querySelector('.product-card');
    if (!card) return;
    hydrateQuickAdd(item, card);
    if (item.dataset.sfSparePartsEnhanced === 'true') return;
    item.dataset.sfSparePartsEnhanced = 'true';
    card.classList.add('sf-parts-card');
    card.dataset.fitmentTags = item.dataset.fitmentTags || item.dataset.sfProductTags || '';

    var productUrl = sparePartsProductUrl(item.dataset.sfProductUrl || (card.querySelector('a[href*="/products/"]') || {}).href || '');
    if (productUrl) {
      item.dataset.sfProductUrl = productUrl;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        link.href = productUrl;
      });
    }
    var favoriteId = item.dataset.sfProductHandle || productUrl;
    if (favoriteId && !card.querySelector('.sf-spare-parts-card__favorite')) {
      var favorite = document.createElement('button');
      favorite.type = 'button';
      favorite.className = 'sf-spare-parts-card__favorite';
      favorite.dataset.sfPartsFavorite = favoriteId;
      favorite.innerHTML = heartMarkup();
      var favorites = favoriteSet();
      var pressed = favorites.has(favoriteId);
      favorite.setAttribute('aria-pressed', String(pressed));
      favorite.setAttribute('aria-label', pressed ? strings.favoriteRemove : strings.favoriteAdd);
      card.appendChild(favorite);
    }

    var information = card.querySelector('.product-card__information, .product-card__content');
    if (!information || information.querySelector('.sf-spare-parts-card__facts')) return;
    var partNumber = item.dataset.sfPartNumber || '';
    var brands = item.dataset.sfCompatibleBrands || '';
    var available = item.dataset.sfProductAvailable !== 'false';
    var facts = document.createElement('div');
    facts.className = 'sf-spare-parts-card__facts';
    if (partNumber) {
      var number = document.createElement('span');
      number.className = 'sf-spare-parts-card__part-number';
      number.textContent = partNumber;
      facts.appendChild(number);
    }
    if (brands) {
      var brandList = document.createElement('span');
      brandList.className = 'sf-spare-parts-card__brands';
      brandList.textContent = strings.compatibleBrands + brands;
      facts.appendChild(brandList);
    }
    var stock = document.createElement('span');
    stock.className = 'sf-spare-parts-card__stock' + (available ? '' : ' is-unavailable');
    stock.textContent = available ? strings.available : strings.unavailable;
    facts.appendChild(stock);
    var heading = information.querySelector('.product-card__heading');
    var headingLink = heading && heading.querySelector('a');
    if (headingLink) {
      var fullTitle = headingLink.textContent.trim();
      var shortTitle = fullTitle
        .replace(/^SENFINECO\s*/i, '')
        .split(/\s*[|｜]\s*|\s+OEM\b/i)[0]
        .trim();
      if (shortTitle && shortTitle !== fullTitle) {
        headingLink.title = fullTitle;
        headingLink.textContent = shortTitle;
      }
    }
    if (heading) heading.insertAdjacentElement('afterend', facts);
    else information.prepend(facts);
  }

  function handleFavorite(button) {
    var id = button.dataset.sfPartsFavorite;
    if (!id) return;
    var favorites = favoriteSet();
    if (favorites.has(id)) favorites.delete(id);
    else favorites.add(id);
    saveFavoriteSet(favorites);
    var pressed = favorites.has(id);
    button.setAttribute('aria-pressed', String(pressed));
    button.setAttribute('aria-label', pressed ? strings.favoriteRemove : strings.favoriteAdd);
  }

  function fitmentRecords(details) {
    var script = details.querySelector('[data-sf-parts-fitments-json]');
    var records = script ? safeParse(script.textContent || '', []) : [];
    if (Array.isArray(records) && records.length) return records;
    var providerIds = (details.dataset.providerVehicleIds || '').split('||').filter(Boolean);
    if (providerIds.length) return [{ providerVehicleIds: providerIds, status: details.dataset.fitmentStatus || '' }];
    return (details.dataset.fitmentTags || '')
      .split('||')
      .map(function (tag) { return tag.trim(); })
      .filter(function (tag) { return /-(?:esi|esr)\d+$/i.test(tag); })
      .map(function (tag) { return { easysearchTag: tag }; });
  }

  function compact(value) {
    return normalize(value).replace(/\b(?:cylinder|cylinders|cyl|سلندر)\b/g, '').replace(/[^\p{L}\p{N}]/gu, '');
  }

  function easysearchTagMatches(vehicle, tag) {
    var raw = String(tag || '').replace(/-(?:esi|esr)\d+$/i, '');
    var normalizedTag = normalize(raw);
    var compactTag = compact(raw);
    var make = compact(vehicle.make);
    var model = compact(vehicle.model);
    var engine = compact(vehicle.engine);
    if (!make || !model || !engine) return false;
    if (compactTag.indexOf(make) === -1 || compactTag.indexOf(model) === -1) return false;

    var years = normalizedTag.match(/(?:19|20)\d{2}/g) || [];
    var selectedYear = parseInt(vehicle.year, 10);
    if (!selectedYear || !years.length) return false;
    var from = parseInt(years[0], 10);
    var to = parseInt(years[1] || years[0], 10);
    if (selectedYear < from || selectedYear > to) return false;

    var engineWithoutCylinder = engine.replace(/(?:4|6|8|10|12)(?:cylinder|cylinders|cyl|سلندر)$/i, '');
    return compactTag.indexOf(engine) !== -1 || (engineWithoutCylinder && compactTag.indexOf(engineWithoutCylinder) !== -1);
  }

  function yearMatches(selectedYear, record) {
    var year = parseInt(selectedYear, 10);
    if (!year) return true;
    var from = parseInt(record.year_from || record.yearFrom || record.year || 0, 10);
    var to = parseInt(record.year_to || record.yearTo || record.year || 0, 10);
    if (!from && !to) return true;
    if (!to) to = from;
    if (!from) from = to;
    return year >= from && year <= to;
  }

  function textMatches(selected, expected) {
    if (!selected || !expected) return true;
    var left = normalize(selected);
    var right = normalize(expected);
    return left === right || left.indexOf(right) !== -1 || right.indexOf(left) !== -1;
  }

  function recordMatches(vehicle, record) {
    if (!record || typeof record !== 'object') return false;
    if (record.easysearchTag) return vehicle.source === 'vin' ? false : easysearchTagMatches(vehicle, record.easysearchTag);
    var providerIds = record.providerVehicleIds || record.provider_vehicle_ids || record.providerVehicleId || record.provider_vehicle_id || [];
    if (!Array.isArray(providerIds)) providerIds = String(providerIds || '').split('||');
    var providerVerified = record.verified === true || normalize(record.status) === 'verified';
    if (vehicle.source === 'vin' && vehicle.providerVehicleId && providerVerified && providerIds.length) {
      return providerIds.map(String).indexOf(String(vehicle.providerVehicleId)) !== -1;
    }
    var verified = record.verified === true || normalize(record.status) === 'verified';
    var make = record.make || record.vehicle_make;
    var model = record.model || record.vehicle_model;
    var engine = record.engine || record.engine_name;
    var hasYear = record.year || record.year_from || record.yearFrom || record.year_to || record.yearTo;
    if (!verified || !make || !model || !engine || !hasYear) return false;
    return (
      textMatches(vehicle.make, make) &&
      textMatches(vehicle.model, model) &&
      yearMatches(vehicle.year, record) &&
      textMatches(vehicle.engine, engine)
    );
  }

  function paintFitment(details, vehicle) {
    var result = details.querySelector('[data-sf-parts-fitment-result]');
    if (!result) return;
    var title = result.querySelector('[data-sf-parts-fitment-title]');
    var note = result.querySelector('[data-sf-parts-fitment-note]');
    var records = fitmentRecords(details);
    var state = 'choose';
    if (vehicle) state = records.some(function (record) { return recordMatches(vehicle, record); }) ? 'match' : 'unverified';
    result.dataset.state = state;
    if (state === 'match') {
      setText(title, strings.fitmentMatch);
      setText(note, strings.fitmentMatchNote + ' ' + vehicle.label);
    } else if (state === 'unverified') {
      setText(title, strings.fitmentUnknown);
      setText(note, strings.fitmentUnknownNote + ' ' + vehicle.label);
    } else {
      setText(title, strings.chooseVehicle);
      setText(note, strings.chooseVehicleNote);
    }
  }

  function initProductDetails(details) {
    if (!details || details.dataset.sfPartsDetailsReady === 'true') return;
    details.dataset.sfPartsDetailsReady = 'true';
    paintFitment(details, savedVehicle());
    document.addEventListener('sf:parts-vehicle-change', function (event) {
      paintFitment(details, event.detail || null);
    });
  }

  function boot(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    document.body && document.body.classList.add('sf-spare-parts-page');
    if (document.body) document.body.dataset.sfCardFitmentEnabled = 'true';
    paintSavedVehicle(savedVehicle());
    context.querySelectorAll('[data-sf-parts-vehicle-filter]').forEach(function (root) {
      initVehicleFilter(root);
    });
    context.querySelectorAll('[data-sf-spare-parts-browser]').forEach(function (browser) {
      applyCategoryImageOverrides(browser);
      initCategorySearch(browser);
      initFamilyAccordion(browser);
      initCatalogFilters(browser);
      initConsumablesCatalog(browser);
      restoreSavedVehicleResults(browser);
    });
    context.querySelectorAll('[data-sf-parts-product-search]').forEach(initProductSearch);
    context.querySelectorAll('[data-sf-spare-parts-product]').forEach(enhanceProductItem);
    context.querySelectorAll('[data-sf-spare-parts-product-details]').forEach(initProductDetails);
  }

  document.addEventListener('sf:parts-vehicle-change', function (event) {
    paintSavedVehicle(event.detail || null);
    document.querySelectorAll('[data-sf-spare-parts-browser]').forEach(refreshConsumablesCatalog);
  });

  document.addEventListener('pointerdown', function (event) {
    var control = event.target.closest('.sf-grid-cart, .sf-parts-card__cart');
    if (control) hydrateQuickAddFromControl(control);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-sf-grid-cart], form.sf-grid-cart-form, form.sf-parts-card__cart-form');
    if (form) hydrateQuickAddFromControl(form);
  }, true);

  document.addEventListener('click', function (event) {
    var cartControl = event.target.closest('.sf-grid-cart, .sf-parts-card__cart');
    if (cartControl) hydrateQuickAddFromControl(cartControl);
    var favorite = event.target.closest('[data-sf-parts-favorite]');
    if (!favorite) return;
    event.preventDefault();
    event.stopPropagation();
    handleFavorite(favorite);
  }, true);

  boot(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  }
  var mutationTimer = 0;
  new MutationObserver(function (mutations) {
    if (!mutations.some(function (mutation) { return mutation.addedNodes.length; })) return;
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(function () { boot(document); }, 80);
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  window.senfinecoSpareParts = {
    getVehicle: savedVehicle,
    applyVehicle: applyVehicleToEasySearch,
    clearVehicle: function () { resetVehicle(vehicleRoot(document)); }
  };
})();
